import { render, staticRenderFns } from "./DefinitionEditor.vue?vue&type=template&id=c904bc6c"
import script from "./DefinitionEditor.vue?vue&type=script&lang=ts"
export * from "./DefinitionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports